import { render, staticRenderFns } from "./DefaultNotification.vue?vue&type=template&id=3cade226&scoped=true&"
import script from "./DefaultNotification.vue?vue&type=script&lang=js&"
export * from "./DefaultNotification.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNotification.vue?vue&type=style&index=0&id=3cade226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cade226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VSheet})
